var exports = {
  "i": "x31de4314--34dab6--wrapper",
};

module.exports = exports;
